import log from "loglevel";
import { Extrude } from "drei";
import SETTINGS from "../../settings";

const SectionPlane = (props) => {
  log.info("SectionPlane");
  // log.info(props);
  const heightMap = props.heightMap;
  const size = heightMap.boundBox.size;
  const noOfVertices = heightMap.noOfVertices;
  const min = heightMap.heightLimits.min;
  const altitudes = heightMap.altitudes;
  const scale = SETTINGS.TERRAIN.SCALE;

  const y = Math.floor(props.controlData.date * (noOfVertices.y - 1));
  let sectionAlongY;
  for (let i = 0; i < noOfVertices.x; i++) {
    let point = {};
    point.z = (altitudes[i][y] - min) / scale;
    point.x = ((i / (noOfVertices.x - 1)) * size.x - size.x / 2) / scale;
    if (!sectionAlongY) {
      sectionAlongY = new THREE.Shape();
      sectionAlongY.moveTo(point.x, point.z);
    } else {
      sectionAlongY.lineTo(point.x, point.z);
    }
  }
  sectionAlongY.lineTo(+size.x / (2 * scale), -0.1);
  sectionAlongY.lineTo(-size.x / (2 * scale), -0.1);

  const x = Math.floor(props.controlData.time * (noOfVertices.x - 1));
  let sectionAlongX;
  // log.info(noOfVertices);
  for (let i = 0; i < noOfVertices.y; i++) {
    let point = {};
    // log.info(i, x);
    // log.info(altitudes[x][i]);
    point.z = (altitudes[x][i] - min) / scale;
    point.y = ((i / (noOfVertices.y - 1)) * size.y - size.y / 2) / scale;
    if (!sectionAlongX) {
      sectionAlongX = new THREE.Shape();
      sectionAlongX.moveTo(point.y, point.z);
    } else {
      sectionAlongX.lineTo(point.y, point.z);
    }
  }
  sectionAlongX.lineTo(+size.x / (2 * scale), -0.1);
  sectionAlongX.lineTo(-size.x / (2 * scale), -0.1);

  const extrudeSettings = {
    steps: 1,
    depth: 0.01,
    bevelEnabled: false,
  };
  return (
    <>
      <Extrude
        args={[sectionAlongY, extrudeSettings]}
        position={[
          0,
          0,
          ((y / (noOfVertices.y - 1)) * size.y - size.y / 2) / scale,
        ]}
        rotation={[0, 0, 0]}
      >
        <meshLambertMaterial attach="material" color={0xeeee00} />
      </Extrude>
      <Extrude
        args={[sectionAlongX, extrudeSettings]}
        position={[
          ((x / (noOfVertices.x - 1)) * size.x - size.x / 2) / scale,
          0,
          0,
        ]}
        rotation={[0, -Math.PI / 2, 0]}
      >
        <meshLambertMaterial attach="material" color={0x00ee00} />
      </Extrude>
    </>
  );
};

export default React.memo(SectionPlane);
